export default __webpack_public_path__ + "13335fea484d886ba6668bd313f470c4.png";